import { z } from 'zod'
import { ExclusiveOfferType } from '~library/enums'
import { dateValueSchema } from '~library/models'
import { exclusiveOfferContentSchema } from './exclusive-offer-content'

/** 取得會員尊享明細資料 */
export const exclusiveOfferDetailDataSchema = z.object({
  /** 分類 */
  type: z.enum(ExclusiveOfferType),
  /** 航點 */
  airportCode: z.array(z.string()),
  /** 權重 */
  priority: z.string(),
  /** 時區 */
  timeZone: z.string(),
  /** 活動起始日期 */
  activityStartTime: dateValueSchema,
  /** 活動截止日期 */
  activityEndTime: dateValueSchema,
  /** 新商品 */
  newTag: z.boolean(),
  /** 限時 */
  flashSale: z.boolean(),
  /** 限量 */
  limitedEdition: z.boolean(),
  /** 優惠碼 */
  promoCode: z.string(),
  /** 內容 - 繁體中文 */
  contentZh: exclusiveOfferContentSchema,
  /** 內容 - 簡體中文 */
  contentCn: exclusiveOfferContentSchema,
  /** 內容 - 英文 */
  contentEn: exclusiveOfferContentSchema
})

export interface ExclusiveOfferDetailData extends z.infer<
  typeof exclusiveOfferDetailDataSchema
> {}
